module.exports = __webpack_public_path__ + "static/img/logo.8bc4c213.png";